import { mediaQueries, palette } from '@centivo/react-components'
import styled, { css } from 'styled-components'

export const Slider = styled.input`
  appearance: none;
  width: 100%;
  height: 4px;
  background-color: ${palette.brand.lightPurple};

  @media ${mediaQueries.mobile} {
    background-color: #ececec;
  }

  ${({ theme }) => {
    switch (theme.template) {
      case 'template-4':
        return css`
          border-radius: 8px;
        `
      default:
        return {}
    }
  }}

  &:hover {
    opacity: 1;
  }

  &:focus {
    border: 1px solid ${palette.ui.blue};
  }

  &::-webkit-slider-thumb {
    appearance: none;
    width: 1.5rem;
    height: 1.5rem;
    background: ${palette.brand.newPurple};
    cursor: pointer;
    border-radius: 100%;
    box-shadow: 0px 0.125rem 0.25rem rgba(0, 0, 0, 0.2);
  }

  &::-moz-range-thumb {
    width: 25px; /* Set a specific slider handle width */
    height: 25px; /* Slider handle height */
    background: ${palette.brand.newPurple};
    cursor: pointer; /* Cursor on hover */
  }
`
